import { StringUnionKeyAsValue } from '../ts/helpers/TypescriptHelpers';

export type CatalogContentType = 'database' | 'databaseWithCrass' | 'table';

export const CatalogContentTypes: StringUnionKeyAsValue<CatalogContentType> = {
  databaseWithCrass: 'databaseWithCrass',
  database: 'database',
  table: 'table',
};
